import type { BelegStatus } from "@/api/types";
import { STATUS_LABEL } from "@/api/types";

import "./StatusBadge.css";

interface StatusBadgeProps {
  status: BelegStatus;
  size?: "sm" | "md";
}

export function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
  // Mapping: Status -> CSS-Class. So koennen Custom Properties pro Status
  // greifen, ohne zur Laufzeit Style-Objekte zu bauen.
  return (
    <span
      className={`bmd-status bmd-status-${status} bmd-status-${size}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
